/* eslint-disable no-param-reassign */
export default function mobileMenu() {
  const { body } = document;
  const hamburger = document.querySelectorAll('.site-mobile-button .hamburger');
  const homeHamburger = document.querySelector('.site-mobile-button-home .hamburger');
  const portal = document.querySelector('.mobile-nav-portals .mobile-nav--title a');
  const portalWrap = document.querySelector('.mobile-nav-portals');
  const resources = document.querySelector('.mobile-nav-resources .mobile-nav--title a');
  const resourcesWrap = document.querySelector('.mobile-nav-resources');
  const nav = document.querySelector('.site-header-sticky');

  hamburger.forEach((hamburgerButton) => {
    hamburgerButton.onclick = function onclick() {
      if (hamburgerButton.tagName.toLowerCase() !== 'a') {
        hamburgerButton.classList.toggle('is-active');
        body.classList.toggle('mm-active');
      }
      const windowY = window.scrollY;
      if (windowY < window.innerHeight) {
        nav.classList.remove('is-initial');
        nav.classList.add('is-hidden');
        nav.classList.remove('is-visible');
      } else {
        nav.classList.remove('is-initial');
        nav.classList.add('is-visible');
        nav.classList.remove('is-hidden');
      }
    };
  });
  if (homeHamburger) {
    homeHamburger.onclick = function onclick() {
      body.classList.toggle('mm-active');
      nav.classList.remove('is-initial');
      nav.classList.add('is-visible');
      nav.classList.remove('is-hidden');
      hamburger.forEach((hamburgerButton) => {
        if (hamburgerButton.tagName.toLowerCase() !== 'a') {
          hamburgerButton.classList.toggle('is-active');
        }
      });
    };
  }
  window.onresize = function onresize() {
    if (window.innerWidth > 1200) {
      body.classList.remove('mm-active');
    }
  };


  if (portal) {
    portal.onclick = function onclick(evt) {
      const elementClasses = (` ${portalWrap.className} `).replace(/[\n\t\r]/g, ' ');
      let removeClass = 'slide-down';
      let addClass = 'slide-up';
      const isShowing = elementClasses.indexOf(` ${removeClass} `) > -1;
      evt.preventDefault();
      if (!isShowing) {
        // eslint-disable-next-line prefer-destructuring
        removeClass = [addClass, addClass = removeClass][0];
      }
      portalWrap.className = (`${elementClasses.replace(` ${removeClass} `, '')} ${addClass} `).trim();
      return false;
    };
  }
  if (resources) {
    resources.onclick = function onclick(evt) {
      const elementClasses = (` ${resourcesWrap.className} `).replace(/[\n\t\r]/g, ' ');
      let removeClass = 'slide-down';
      let addClass = 'slide-up';
      const isShowing = elementClasses.indexOf(` ${removeClass} `) > -1;
      evt.preventDefault();
      if (!isShowing) {
        // eslint-disable-next-line prefer-destructuring
        removeClass = [addClass, addClass = removeClass][0];
      }
      resourcesWrap.className = (`${elementClasses.replace(` ${removeClass} `, '')} ${addClass} `).trim();
      return false;
    };
  }
}
